import { Dataset, districtOptionsData, HousingOption, viewData } from '@interface';


const districtList: districtOptionsData[] = [
	{ value: 'council', label: 'Council District' },
	{ value: 'community', label: 'Community District' },
	{ value: 'state-assembly', label: 'State Assembly' },
	{ value: 'state-senate', label: 'State Senate' },
	{ value: 'zipcode', label: 'Zip Code' },
]

export const districtOptions: districtOptionsData[] = [
	{ value: '', label: 'Select' },
	...districtList
];

export const geographyOptions: districtOptionsData[] = [
	{ value: '', label: 'Select a geography' },
	...districtList,
	{ value: 'borough', label: 'Borough' },
	{ value: 'city', label: 'New York City' }]

export const boroughList: districtOptionsData[] = [
	{ value: '', label: 'Select' },
	{ label: "Manhattan", value: "MN" },
	{ label: "Bronx", value: "BX" },
	{ label: "Brooklyn", value: "BK" },
	{ label: "Queens", value: "QN" },
	{ label: "Staten Island", value: "SI" },
];

export const tabHeading = {
	salesAndFinancing: "Sales",
	marshalEvictions: "Marshal Evictions",
	hpdComplaints: "HPD Complaints and Problems",
	hpdViolations: "HPD Violations",
	dobComplaints: "DOB Complaints",
	dobViolations: "DOB Violations",
	ecbViolations: "ECB Violations",
	dobFiledPermits: "DOB Permit Applications",
	dobIssuedPermits: "DOB Permits Issued",
	housingLitigations: "Litigations Against Landlord"
}

export const tabData = [
	{ label: 'Sales (...) and Financing', key: 'salesAndFinancing' },
	{ label: 'Marshal Evictions (...)', key: 'marshalEvictions' },
	{ label: 'HPD Complaints and Problems (...)', key: 'hpdComplaints' },
	{ label: 'HPD Violations (...)', key: 'hpdViolations' },
	{ label: 'DOB Complaints (...)', key: 'dobComplaints' },
	{ label: 'DOB Violations (...)', key: 'dobViolations' },
	{ label: 'ECB Violations (...)', key: 'ecbViolations' },
	{ label: 'DOB Permit Applications (...)', key: 'dobFiledPermits' },
	{ label: 'DOB Permits Issued (...)', key: 'dobIssuedPermits' },
	{ label: 'Litigations Against Landlord (...)', key: 'housingLitigations' },
];

export const filterData = {
	salesAndFinancing: [
		{ label: 'All', value: 'all' },
		{ label: 'Deed', value: 'deed' },
		{ label: 'Mortgage', value: 'mortgage' }
	],
	marshalEvictions: [],
	hpdComplaints: [
		{ label: 'All', value: 'all' },
		{ label: 'Open', value: 'Open' },
		{ label: 'Closed', value: 'Closed' }
	],
	hpdViolations: [
		{ label: 'All', value: 'all' },
		{ label: 'Open', value: 'Open' },
		{ label: 'Closed', value: 'Closed' },
		{ label: 'Class A', value: 'A' },
		{ label: 'Class B', value: 'B' },
		{ label: 'Class C', value: 'C' }
	],
	dobComplaints: [
		{ label: 'All', value: 'all' },
		{ label: 'Active', value: 'Active' },
		{ label: 'Closed', value: 'Closed' }
	],
	dobViolations: [
		{ label: 'All', value: 'all' },
		{ label: 'Active', value: 'active' },
		{ label: 'Dismissed', value: 'dismissed' },
	],
	ecbViolations: [
		{ label: 'All', value: 'all' },
		{ label: 'Active', value: 'active' },
		{ label: 'Resolved', value: 'resolved' },
	],
	dobFiledPermits: [
		{ label: 'All', value: 'all' },
		{ label: 'A1', value: 'A1' },
		{ label: 'A2', value: 'A2' },
		{ label: 'A3', value: 'A3' },
		{ label: 'NB', value: 'NB' },
		{ label: 'DM', value: 'DM' },
	],
	dobIssuedPermits: [
		{ label: 'All', value: 'all' },
		{ label: 'A1', value: 'A1' },
		{ label: 'A2', value: 'A2' },
		{ label: 'A3', value: 'A3' },
		{ label: 'NB', value: 'NB' },
		{ label: 'DM', value: 'DM' },
	],
	housingLitigations: []
};


export const councilDistrictOptions: districtOptionsData[] = [
	{ value: '', label: '#' },
	...Array.from({ length: 51 }, (_, i) => ({
		value: `${i + 1}`,
		label: `${i + 1}`,
	}))
]

export const communityDistrictOptions: districtOptionsData[] = [
	{ value: '', label: '#' },
	...Array.from({ length: 12 }, (_, i) => ({
		value: `${i + 101}`,
		label: `Manhattan ${i + 1}`,
	})),
	...Array.from({ length: 12 }, (_, i) => ({
		value: `${i + 201}`,
		label: `Bronx ${i + 1}`,
	})),
	...Array.from({ length: 18 }, (_, i) => ({
		value: `${i + 301}`,
		label: `Brooklyn ${i + 1}`,
	})),
	...Array.from({ length: 14 }, (_, i) => ({
		value: `${i + 401}`,
		label: `Queens ${i + 1}`,
	})),
	...Array.from({ length: 3 }, (_, i) => ({
		value: `${i + 501}`,
		label: `Staten Island ${i + 1}`,
	})),
];

export const stateAssemblyOptions: districtOptionsData[] = [
	{ value: '', label: '#' },
	...Array.from({ length: 87 - 23 + 1 }, (_, i) => ({
		value: `${i + 23}`,
		label: `${i + 23}`,
	}))
]

export const stateSenateOptions: districtOptionsData[] = [
	{ value: '', label: '#' },
	...Array.from({ length: 59 - 10 + 1 }, (_, i) => ({
		value: `${i + 10}`,
		label: `${i + 10}`,
	}))
]

export const zipCodeOptions: districtOptionsData[] = [

	// Manhattan (10001–10282)
	...Array.from({ length: 282 }, (_, i) => ({
		value: `${10001 + i}`,
		label: `${10001 + i}`,
	})).filter((zip) => parseInt(zip.value) <= 10282),

	// Bronx (10451–10475)
	...Array.from({ length: 25 }, (_, i) => ({
		value: `${10451 + i}`,
		label: `${10451 + i}`,
	})),

	// Brooklyn (11201–11256)
	...Array.from({ length: 56 }, (_, i) => ({
		value: `${11201 + i}`,
		label: `${11201 + i}`,
	})),

	// Queens (11004–11109 and 11351–11697)
	...Array.from({ length: 6 }, (_, i) => ({
		value: `${11004 + i}`,
		label: `${11004 + i}`,
	})),
	...Array.from({ length: 9 }, (_, i) => ({
		value: `${11101 + i}`,
		label: `${11101 + i}`,
	})),
	...Array.from({ length: 147 }, (_, i) => ({
		value: `${11351 + i}`,
		label: `${11351 + i}`,
	})).filter((zip) => parseInt(zip.value) <= 11697),

	// Staten Island (10301–10314)
	...Array.from({ length: 14 }, (_, i) => ({
		value: `${10301 + i}`,
		label: `${10301 + i}`,
	})),
];

export const menuItems = [
	{ label: 'Home', to: '/' },
	{ label: 'My Dashboard', to: '/me' },
	{ label: 'Property Lookup', to: '/lookup' },
	{ label: 'District Dashboard', to: '/district-dashboard' },
	{ label: 'Custom Search', to: '/search' },
	{ label: 'Contact us / Report an issue', to: '#' },
	{ label: 'Login / Sign up', to: '#' },
];

export const housingOptionsInitalData: HousingOption[] = [
	{
		label: 'All Residential Housing',
		value: 'all',
		tooltip: false,
		units: 0,
		dataCount: 0,
		data: [],
	},
	{
		label: 'Rent Stabilized',
		value: 'rent',
		percentage: 0.0,
		tooltip: true,
		units: 0,
		dataCount: 0,
		data: [],
	},
	{
		label: 'Subsidized Housing',
		value: 'subsidized',
		percentage: 0.0,
		tooltip: true,
		units: 0,
		dataCount: 0,
		data: [],
	},
	{
		label: 'Small Homes',
		value: 'small',
		percentage: 0.0,
		tooltip: true,
		units: 0,
		dataCount: 0,
		data: [],
	},
	{
		label: 'Market Rate',
		value: 'market',
		percentage: 0.0,
		tooltip: true,
		units: 0,
		dataCount: 0,
		data: [],
	},
	{
		label: 'Public Housing',
		value: 'public',
		percentage: 0.0,
		tooltip: true,
		units: 0,
		dataCount: 0,
		data: [],
	},
]

export const DistrictDatasetOptions: Dataset[] = [
	{
		id: 'sales',
		label: 'Sales',
		unit: 'Sales',
		tooltip: true,
	},
	{
		id: 'hpd-complaints',
		label: 'HPD Complaints & Problems',
		unit: 'HPD complaints & problems',
		tooltip: true,
	},
	{
		id: 'hpd-violations',
		label: 'HPD Violations',
		unit: 'HPD Violations',
		tooltip: true,
	},
	{
		id: 'dob-complaints',
		label: 'DOB Complaints',
		unit: 'DOB Complaints',
		tooltip: true,
	},
	{
		id: 'dob-permits',
		label: 'DOB Permit Applications',
		unit: 'DOB Permit Application',
		tooltip: true,
	},
];

export const viewDataOptions: viewData[] = [
	{ id: '30_days', value: '30_days', label: 'Last 30 Days' },
	{ id: '1_year', value: '1_year', label: 'Last Year' },
	{ id: '3_years', value: '3_years', label: 'Last 3 Years' },
];

export const initialPropertyData = {
	sales: 0,
	'hpd-complaints': 0,
	'hpd-violations': 0,
	'dob-complaints': 0,
	'dob-permits': 0,
}

export const thresholdsOptions = {
	sales: 1,
	'hpd-complaints': 5,
	'hpd-violations': 10,
	'dob-complaints': 2,
	'dob-permits': 1,
}

export const propertyMapping: Record<string, string> = {
	"Sales": "sales",
	"HPD Problems": "hpd-complaints",
	"HPD Violations": "hpd-violations",
	"DOB Complaints": "dob-complaints",
	"DOB Permit Applications": "dob-permits",
};


export const districtAPIobj: Record<string, string> = {
	"council": "councils",
	"community": "communities",
	"state-assembly": "stateassemblies",
	"state-senate": "statesenates",
	"zipcode": "zipcodes"
}
